
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/line-oa-development",
      function () {
        return require("private-next-pages/services/line-oa-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/line-oa-development"])
      });
    }
  